import {gql} from '@apollo/client'
import defaultPageData from '../_partials/defaultPageData'


const queryPrivacyPolicy = gql`
query GET_PRIVACY_POLICY_PAGE(
  $title: String
){
    pages(where: {title: $title}){
      edges{
        node{
          id
          title
          content
          blocksJSON
        }
      }
    }
  } 
`

export default queryPrivacyPolicy